var _rect, _rect2, _path, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreyPound = function SvgGreyPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261,
    height: 96,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.47,
    height: 79.949,
    x: 0.18,
    y: 8.013,
    fill: "#B4B4B4",
    rx: 39.735
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 79.47,
    height: 79.949,
    x: 181.35,
    y: 8.013,
    fill: "#B4B4B4",
    rx: 39.735
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.851 51.543h9.553v-5.629H36.85v-3.209c0-3.752 2.315-6.073 5.81-6.073 2.955 0 5.023 1.58 5.614 4.345h6.549c-.739-6.172-5.417-10.073-12.162-10.073-7.337 0-12.26 4.642-12.26 11.801v3.21h-2.906v5.628h2.905v7.9h-2.905v5.629h26.688v-5.629H36.85zM216.777 51.543h9.553v-5.629h-9.553v-3.209c0-3.752 2.314-6.073 5.81-6.073 2.955 0 5.023 1.58 5.614 4.345h6.549c-.739-6.172-5.417-10.073-12.163-10.073-7.336 0-12.26 4.642-12.26 11.801v3.21h-2.905v5.628h2.905v7.9h-2.905v5.629h26.687v-5.629h-17.332z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94.567,
    x: 83.5,
    y: 0.704,
    fill: "#848484",
    rx: 47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.404 52.193h11.299v-6.658h-11.299v-3.796c0-4.439 2.737-7.184 6.872-7.184 3.495 0 5.941 1.869 6.64 5.14h7.746c-.874-7.3-6.407-11.915-14.386-11.915-8.678 0-14.502 5.49-14.502 13.959v3.796h-3.436v6.658h3.436v9.344h-3.436v6.658h31.567v-6.658h-20.501z"
  })));
};
export { SvgGreyPound as ReactComponent };
export default __webpack_public_path__ + "images/grey-pound.svg";